import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text info mb-10 mt-20"
}
const _hoisted_2 = {
  key: 1,
  class: "text-warning mb-10 mt-20"
}

import { computed } from 'vue'
import { useStore } from 'vuex'
import { resourceNames } from '@shell/utils/string'


export default /*@__PURE__*/_defineComponent({
  __name: 'services',
  props: {
    value: {},
    names: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore()
const t = store.getters['i18n/t'];

const plusMore = computed(() => {
  const remaining = props.names.length - 5; //5 is the max specified in resourceNames func
  return t('promptRemove.andOthers', { count: remaining })
})

const bounded = computed(() => {
  return props.value?.reduce((acc, svc) => {
    const apps = svc?.boundapps ?? []
    return [...acc, ...apps]
  }, []) || []
})


return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_unref(t)('promptRemove.attemptingToRemove', { type: _ctx.type })) + " ", 1),
    _withDirectives(_createElementVNode("span", null, null, 512), [
      [_directive_clean_html, _unref(resourceNames)(props.names, plusMore.value, _unref(t))]
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (!bounded.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('epinio.services.applicationsNotBound')), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon icon-checkmark" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (bounded.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('epinio.services.applicationsBound', { count: bounded.value.length })), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})